import CustomElement from '~utilities/custom-element';
import TabIndexChildren from '~utilities/tab-index-children';

const IS_ACTIVE = 'is--active';

class Expand extends CustomElement {
	constructor() {
		super();
		this.content = document.getElementById(this.getAttribute('js-expand-id'));

    console.log(this.content);
	}
	
	template() {
    const className = this.getAttribute('class');

		return `
			<button class="c-expand ${className ? className : ''}" aria-expanded="${this.getAttribute('aria-expanded')}" aria-controls="${this.getAttribute('js-expand-id')}" data-expand="${this.dataset.expand}" data-collapse="${this.dataset.collapse}">${this.innerHTML}</button>
		`;
	}

	callback() {
		super.callback();

    if(this.element.getAttribute('aria-expanded') === 'true') {
      this.toggleContent(true);
    }
		
		this.element.addEventListener('click', (event) => {
			event.preventDefault();
			
      const active = !this.content.classList.contains(IS_ACTIVE);
			this.toggleContent(active);
		});

    this.content.addEventListener('click', (event) => {
      this.resizeHeight();
    })
	}

  resizeHeight() {
    this.content.style.maxHeight = `${this.content.scrollHeight}px`;
  }

  toggleContent(active) {
    const toggle = active ? 'add' : 'remove';
    const expanded = active ? 'true' : 'false';
    const height = active ? this.content.scrollHeight : 0;
    const tabIndex = active ? 0 : -1;

    this.element.classList[toggle](IS_ACTIVE);
    this.content.classList[toggle](IS_ACTIVE);
    
    this.element.setAttribute('aria-expanded', `${expanded}`);
    this.content.style.maxHeight = `${height}px`;
    new TabIndexChildren(this.content, tabIndex, true);
  }
}

export default Expand;